/* Rel Snacks 2026 theme behaviour. Fully event-delegated so it survives InstantClick page swaps. */
(function () {
  'use strict';
  var D = document;
  function qs(sel, root) { return (root || D).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || D).querySelectorAll(sel)); }
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function lock(on) { D.body.style.overflow = on ? 'hidden' : ''; }

  /* ---------------- buy forms ---------------- */
  function syncForm(scope) {
    var pack = qs('.r2-pack[aria-pressed="true"]', scope);
    var plan = qs('.r2-plan button[aria-pressed="true"]', scope);
    var freq = qs('.r2-freq button[aria-pressed="true"]', scope);
    var isSub = plan && plan.getAttribute('data-plan') === 'sub';
    var qty = pack ? parseInt(pack.getAttribute('data-units'), 10) : 1;
    var packTotal = pack ? parseInt(pack.getAttribute('data-total'), 10) : parseInt(scope.getAttribute('data-unit-price'), 10);
    var total = isSub ? Math.round(packTotal * 0.9) : packTotal;
    var qtyInput = qs('input[name="quantity"]', scope);
    if (qtyInput) qtyInput.value = qty;
    var freqRow = qs('.r2-freq', scope);
    if (freqRow) freqRow.hidden = !isSub;
    var planInput = qs('input[name="selling_plan"]', scope);
    if (planInput) planInput.value = isSub && freq ? freq.getAttribute('data-plan-id') : '';
    var now = qs('[data-r2-price-now]', scope);
    if (now) now.textContent = money(total);
    var was = qs('[data-r2-price-was]', scope);
    if (was) { was.textContent = money(packTotal); was.hidden = !isSub; }
    var note = qs('[data-r2-price-note]', scope);
    if (note) note.textContent = isSub && freq ? 'every ' + freq.getAttribute('data-weeks') + ' weeks' : 'one-time';
    var az = qs('[data-r2-amazon]', scope);
    if (az && az.getAttribute('data-asin')) {
      az.href = 'https://www.amazon.com/gp/aws/cart/add.html?ASIN.1=' + az.getAttribute('data-asin') +
        '&Quantity.1=' + qty + '&AssociateTag=' + (az.getAttribute('data-tag') || 'relsnacks-20');
    }
  }

  /* ---------------- cart drawer ---------------- */
  function openDrawer() { var d = qs('#r2-drawer'); if (d) { d.classList.add('is-open'); lock(true); } }
  function closeDrawer() { var d = qs('#r2-drawer'); if (d) { d.classList.remove('is-open'); lock(false); } }
  function cartUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + '?section_id=rel2-cart-drawer';
  }
  function refreshDrawer() {
    return fetch(cartUrl(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = qs('[data-r2-drawer-inner]', doc);
        var host = qs('[data-r2-drawer-inner]');
        if (fresh && host) host.innerHTML = fresh.innerHTML;
        var c = qs('[data-r2-cart-count]', doc);
        if (c) qsa('[data-r2-cart-count]').forEach(function (el) { el.textContent = c.textContent.trim(); });
      })
      .catch(function () {});
  }
  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(refreshDrawer);
  }

  /* ---------------- video player ---------------- */
  function closePlayer() {
    var p = qs('#r2-player');
    if (!p) return;
    p.classList.remove('is-open');
    var v = qs('video', p);
    if (v) { v.pause(); v.muted = true; v.removeAttribute('src'); v.load(); }
    qsa('[data-r2-clip] video').forEach(function (o) { o.muted = true; o.play().catch(function () {}); });
    lock(false);
  }
  function openPlayer(clip) {
    var p = qs('#r2-player');
    var v = p && qs('video', p);
    if (!p || !v) return;
    qsa('[data-r2-clip] video').forEach(function (o) { o.pause(); });
    v.src = clip.getAttribute('data-src');
    v.muted = false;
    v.volume = 1;
    p.classList.add('is-open');
    lock(true);
    v.play().catch(function () {});
  }

  /* ---------------- rails (flavor cards, ugc clips, pdp gallery) ---------------- */
  function railOf(el) { return el.closest('[data-r2-flavrail], [data-r2-ugcrail]'); }
  function scopeRail(scope) { return qs('[data-r2-flavrail], [data-r2-ugcrail]', scope); }
  function railIndex(rail) {
    var mid = rail.scrollLeft + rail.clientWidth / 2, best = 0, bestD = Infinity;
    Array.prototype.slice.call(rail.children).forEach(function (c, i) {
      var d = Math.abs((c.offsetLeft + c.offsetWidth / 2) - mid);
      if (d < bestD) { bestD = d; best = i; }
    });
    return best;
  }
  function railMark(scope, i) {
    var dots = qsa('[data-r2-flavdots] button, [data-r2-ugcdots] button', scope);
    dots.forEach(function (d, n) { d.setAttribute('aria-pressed', n === i ? 'true' : 'false'); });
    var rail = scopeRail(scope);
    var prev = qs('[data-r2-flavprev], [data-r2-ugcprev]', scope);
    var next = qs('[data-r2-flavnext], [data-r2-ugcnext]', scope);
    if (prev) prev.disabled = i <= 0;
    if (next && rail) next.disabled = i >= rail.children.length - 1;
  }
  function railGo(scope, i) {
    var rail = scopeRail(scope);
    if (!rail) return;
    var card = rail.children[i];
    if (!card) return;
    rail.scrollTo({ left: card.offsetLeft - (rail.clientWidth - card.offsetWidth) / 2, behavior: 'smooth' });
    railMark(scope, i);
  }

  /* ---------------- one delegated click handler ---------------- */
  D.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-r2-menu-open]')) {
      var m = qs('#r2-menu');
      if (m) { m.classList.add('is-open'); lock(true); }
      return;
    }
    if (t.closest('[data-r2-menu-close]')) {
      var m2 = qs('#r2-menu');
      if (m2) { m2.classList.remove('is-open'); lock(false); }
      return;
    }
    if (t.closest('[data-r2-cart-open]')) { e.preventDefault(); openDrawer(); return; }
    if (t.closest('[data-r2-cart-close]')) { e.preventDefault(); closeDrawer(); return; }
    if (t.closest('[data-r2-player-close]')) { closePlayer(); return; }

    var clip = t.closest('[data-r2-clip]');
    if (clip) { openPlayer(clip); return; }

    var opt = t.closest('.r2-pack, .r2-plan button, .r2-freq button');
    if (opt) {
      var scope = opt.closest('[data-r2-buyform]');
      if (scope) {
        var sel = opt.classList.contains('r2-pack') ? '.r2-pack'
          : opt.parentNode.classList.contains('r2-plan') ? '.r2-plan button' : '.r2-freq button';
        qsa(sel, scope).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        opt.setAttribute('aria-pressed', 'true');
        syncForm(scope);
      }
      return;
    }

    var acc = t.closest('.r2-acc__btn');
    if (acc) {
      var body = acc.parentNode.querySelector('.r2-acc__body');
      if (body) {
        var open = !body.hidden;
        body.hidden = open;
        var ic = qs('i', acc);
        if (ic) ic.textContent = open ? '+' : '\u2013';
      }
      return;
    }

    var thumb = t.closest('[data-r2-thumb]');
    if (thumb) {
      var wrap = thumb.closest('[data-r2-gallery]');
      var track = wrap && qs('.r2-gal', wrap);
      if (track) {
        var thumbs = qsa('[data-r2-thumb]', wrap);
        var i = thumbs.indexOf(thumb);
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        thumbs.forEach(function (x, n) { x.setAttribute('aria-pressed', n === i ? 'true' : 'false'); });
      }
      return;
    }
    var gnav = t.closest('.r2-gal__nav');
    if (gnav) {
      var gwrap = gnav.closest('[data-r2-gallery]');
      var gtrack = gwrap && qs('.r2-gal', gwrap);
      if (gtrack) gtrack.scrollBy({ left: gnav.classList.contains('r2-gal__nav--prev') ? -gtrack.clientWidth : gtrack.clientWidth, behavior: 'smooth' });
      return;
    }

    var arrow = t.closest('[data-r2-flavprev], [data-r2-flavnext], [data-r2-ugcprev], [data-r2-ugcnext]');
    if (arrow) {
      var aScope = arrow.closest('.r2-wrap');
      var aRail = aScope && scopeRail(aScope);
      if (aRail) {
        var cur = railIndex(aRail);
        var isPrev = arrow.hasAttribute('data-r2-flavprev') || arrow.hasAttribute('data-r2-ugcprev');
        railGo(aScope, Math.max(0, Math.min(aRail.children.length - 1, isPrev ? cur - 1 : cur + 1)));
      }
      return;
    }
    var dot = t.closest('[data-r2-flavdots] button, [data-r2-ugcdots] button');
    if (dot) {
      var dScope = dot.closest('.r2-wrap');
      var holder = dot.parentNode;
      railGo(dScope, Array.prototype.slice.call(holder.children).indexOf(dot));
      return;
    }

    var inc = t.closest('[data-r2-line-inc]');
    if (inc) { changeLine(inc.getAttribute('data-key'), parseInt(inc.getAttribute('data-qty'), 10) + 1); return; }
    var dec = t.closest('[data-r2-line-dec]');
    if (dec) { changeLine(dec.getAttribute('data-key'), parseInt(dec.getAttribute('data-qty'), 10) - 1); return; }
    var rm = t.closest('[data-r2-line-remove]');
    if (rm) { changeLine(rm.getAttribute('data-key'), 0); return; }
    var swap = t.closest('[data-r2-line-swap]');
    if (swap) {
      var key = swap.getAttribute('data-key');
      var q = parseInt(swap.getAttribute('data-qty'), 10);
      var item = { id: swap.getAttribute('data-variant'), quantity: q };
      var plan = swap.getAttribute('data-target-plan');
      if (plan) item.selling_plan = plan;
      changeLine(key, 0).then(function () {
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [item] }) });
      }).then(refreshDrawer);
      return;
    }
    var up = t.closest('[data-r2-upsell-add]');
    if (up) {
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: up.getAttribute('data-variant'), quantity: 1 }] }) }).then(refreshDrawer);
      return;
    }

    var tag = t.closest('[data-r2-store-tag]');
    if (tag) {
      var lroot = tag.closest('[data-r2-locator]');
      qsa('[data-r2-store-tag]', lroot).forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
      tag.setAttribute('aria-pressed', 'true');
      filterStores(lroot);
      return;
    }

    var bstep = t.closest('[data-r2-builder-inc], [data-r2-builder-dec]');
    if (bstep) {
      var row = bstep.closest('[data-r2-builder-row]');
      var el = qs('[data-r2-builder-qty]', row);
      var val = parseInt(el.textContent, 10);
      el.textContent = bstep.hasAttribute('data-r2-builder-inc') ? Math.min(30, val + 10) : Math.max(0, val - 10);
      paintBuilder(bstep.closest('[data-r2-builder]'));
      return;
    }

    var qdot = t.closest('[data-r2-quote-dot]');
    if (qdot) {
      var qblock = qdot.closest('[data-r2-quotes]');
      if (qblock && qblock.__paint) {
        var all = qsa('[data-r2-quote-dot]', qblock);
        qblock.__stop && qblock.__stop();
        qblock.__paint(all.indexOf(qdot));
      }
    }
  });

  D.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closePlayer(); closeDrawer(); } });

  D.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-r2-add]');
    if (!form) return;
    e.preventDefault();
    var btn = qs('[type="submit"]', form);
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function () { return refreshDrawer(); })
      .then(function () { openDrawer(); })
      .catch(function () { form.submit(); })
      .then(function () { if (btn) btn.disabled = false; });
  });

  D.addEventListener('input', function (e) {
    if (e.target.matches('[data-r2-store-search]')) filterStores(e.target.closest('[data-r2-locator]'));
  });

  /* ---------------- store locator ---------------- */
  function filterStores(root) {
    if (!root) return;
    var input = qs('[data-r2-store-search]', root);
    var active = qs('[data-r2-store-tag][aria-pressed="true"]', root);
    var tag = active ? active.getAttribute('data-r2-store-tag') : 'All';
    var q = ((input && input.value) || '').trim().toLowerCase();
    var shown = 0;
    qsa('[data-r2-store]', root).forEach(function (c) {
      var tags = (c.getAttribute('data-tags') || '').toLowerCase();
      var ok = (tag === 'All' || tags.indexOf(tag.toLowerCase()) > -1) && (!q || c.textContent.toLowerCase().indexOf(q) > -1);
      c.hidden = !ok;
      if (ok) shown += 1;
    });
    var status = qs('[data-r2-store-status]', root);
    if (status) status.textContent = shown + (shown === 1 ? ' stockist' : ' stockists');
  }

  /* ---------------- bundle builder ---------------- */
  function paintBuilder(root) {
    if (!root) return;
    var rows = qsa('[data-r2-builder-row]', root);
    var total = rows.reduce(function (a, r) { return a + parseInt(qs('[data-r2-builder-qty]', r).textContent, 10); }, 0);
    var out = qs('[data-r2-builder-count]', root);
    if (out) out.textContent = total;
    var note = qs('[data-r2-builder-note]', root);
    if (note) note.textContent = total === 30 ? 'Perfect \u2014 30 bags' : total < 30 ? 'Add ' + (30 - total) + ' more bags' : 'Remove ' + (total - 30) + ' bags';
    var submit = qs('[data-r2-builder-add]', root);
    if (submit) submit.disabled = total !== 30;
    rows.forEach(function (r) {
      var q = parseInt(qs('[data-r2-builder-qty]', r).textContent, 10);
      var input = qs('input[name*="quantity"]', r);
      if (input) input.value = q / 10;
      var idInput = qs('input[name*="[id]"]', r);
      if (idInput) idInput.disabled = q === 0;
    });
  }

  /* ---------------- per-page init (idempotent) ---------------- */
  function init() {
    qsa('[data-r2-buyform]').forEach(syncForm);
    qsa('[data-r2-locator]').forEach(filterStores);
    qsa('[data-r2-builder]').forEach(paintBuilder);

    qsa('[data-r2-flavrail], [data-r2-ugcrail]').forEach(function (rail) {
      var scope = rail.closest('.r2-wrap');
      if (!rail.dataset.r2Bound) {
        rail.dataset.r2Bound = '1';
        rail.addEventListener('scroll', function () { railMark(scope, railIndex(rail)); });
      }
      railMark(scope, railIndex(rail));
    });

    qsa('[data-r2-gallery]').forEach(function (wrap) {
      var track = qs('.r2-gal', wrap);
      if (!track || track.dataset.r2Bound) return;
      track.dataset.r2Bound = '1';
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        qsa('[data-r2-thumb]', wrap).forEach(function (x, n) { x.setAttribute('aria-pressed', n === i ? 'true' : 'false'); });
      });
    });

    qsa('[data-r2-clip]').forEach(function (clip) {
      var v = qs('video', clip);
      if (!v || clip.dataset.r2Bound) return;
      clip.dataset.r2Bound = '1';
      v.muted = true;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) { v.play().catch(function () {}); } else { v.pause(); } });
        }, { threshold: 0.25 }).observe(clip);
      } else { v.play().catch(function () {}); }
    });

    qsa('[data-r2-quotes]').forEach(function (block) {
      if (block.dataset.r2Bound) return;
      block.dataset.r2Bound = '1';
      var items = [];
      try { items = JSON.parse(qs('[data-r2-quote-data]', block).textContent); } catch (err) { return; }
      if (!items.length) return;
      var textEl = qs('[data-r2-quote-text]', block);
      var authorEl = qs('[data-r2-quote-author]', block);
      var dots = qsa('[data-r2-quote-dot]', block);
      var i = 0, timer;
      block.__paint = function (n) {
        i = (n + items.length) % items.length;
        block.classList.add('is-fading');
        setTimeout(function () {
          if (textEl) textEl.textContent = items[i].quote;
          if (authorEl) authorEl.textContent = items[i].author;
          dots.forEach(function (d, k) { d.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
          block.classList.remove('is-fading');
        }, 190);
      };
      block.__stop = function () { clearInterval(timer); };
      block.__paint(0);
      timer = setInterval(function () { block.__paint(i + 1); }, 4200);
    });

    var bar = qs('[data-r2-buybar]');
    var anchor = qs('[data-r2-buybar-anchor]');
    if (bar && anchor && !bar.dataset.r2Bound && 'IntersectionObserver' in window) {
      bar.dataset.r2Bound = '1';
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { bar.hidden = en.isIntersecting; });
      }, { threshold: 0 }).observe(anchor);
    }
  }

  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init); else init();
  ['shopify:section:load', 'instantclick:newpage', 'page:change', 'turbo:load', 'pjax:end'].forEach(function (ev) {
    D.addEventListener(ev, init);
  });
  window.addEventListener('pageshow', init);
})();
